module.exports = __webpack_public_path__ + "img/@awards_img_00.f425b871.svg";